<template>
  <mdb-chip
    color="white"
    class="z-depth-1 rounded"
    close
    @click.native="handleSearchTagClick(elementId)"
  >{{ label }}</mdb-chip>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    elementId: {
      type: String,
      required: true
    }
  },
  methods: {
    handleSearchTagClick(elementId) {
      this.$emit("removeSearchElement", elementId);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/components/search/_searchTag.scss";
</style>